import { HTTPService } from "../util/httpManager.js";
import { NotificationHelper } from "../util/notificationHelper.js";
import { Config } from "../config/config.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";
export class TreeView extends React.Component<TreeViewProps, any>{
    private _treeData = [];
    private _dataSourceUrl: string;
    private _treeElementRef: any;
    private _treeView: kendo.ui.TreeView;
    private _value: any;

    constructor(props: TreeViewProps) {
        super(props)
        this._dataSourceUrl = props.field.dataSourceUrl;
    }

    private _initTree = () => {
        let dataSource = new kendo.data.HierarchicalDataSource({
            data: this._treeData,
            schema: this.props.field.schema || {}
        });


        this._treeView = $(this._treeElementRef).kendoTreeView({
            dataSource: dataSource,
            dataImageUrlField: this.props.field.imageUrlField || null,
            dataSpriteCssClassField: this.props.field.cssClassField || null,
            template: this.props.field.template || null,
            dataTextField: this.props.field.dataTextField || null,
            expand: (e: kendo.ui.TreeViewExpandEvent) => {
                if (this.props.onExpand) {
                    this.props.onExpand(e);
                }
            },
            collapse: (e: kendo.ui.TreeViewCollapseEvent) => {
                if (this.props.onCollapse) {
                    this.props.onCollapse(e);
                }
            },
            select: (e) => {
                if (this.props.field.unselectableClass && $(e.node).find(".k-in ." + this.props.field.unselectableClass).length > 0) {
                    e.preventDefault();
                } else {
                    if (this.props.onChange) {
                        let item = this._treeView.dataItem(e.node);
                        this.props.onChange(this.props.field, item.id, item);
                    }
                }
            },
        }).data("kendoTreeView");
        this._setTreeNodeByID(this._value);
        if (this.props.field.expand)
            this._treeView.expand(".k-item");
        this.setState({});
    }

    private _getTreeData() {
        HTTPService.get(this._dataSourceUrl)
            .then((result) => {
                this._treeData = result;
                this._value = this.props.value;

                this._initTree();
            }).catch((_result) => {
                NotificationHelper.showErrorMessage(Config.translations.noConnection);
            });
    }

    private _setTreeNodeByID = (_value: any) => {
        let item = this._treeView.dataSource.get(this.props.value);
        if (item != undefined)
            this._treeView.select(this._treeView.findByUid(item.uid));
    }

    public getTreeElementRef = () => {
        return this._treeElementRef;
    }

    public getTreeView = () => {
        return this._treeView;
    }

    setData = (data: any) => {
        this._treeData = data;
        this._treeView.dataSource.data(this._treeData);
    }

    componentDidMount() {
        if (this.props.data) {
            this._treeData = this.props.data;
            this._initTree();
        } else {
            this._getTreeData();
        }
    }

    componentDidUpdate() {
        if (this._value !== this.props.value) {
            this._value = this.props.value;
            this._setTreeNodeByID(this._value);
        }
    }

    render() {
        return (
            <div className="flex-container">
                <div className="flex-container__item" ref={(r) => this._treeElementRef = r} />
            </div>
        );
    }
}
export interface TreeViewProps extends BaseComponentProps {
    field: TreeViewField;
    data?: any | Array<any>;
    onExpand?: (e: kendo.ui.TreeViewExpandEvent) => void;
    onCollapse?: (e: kendo.ui.TreeViewCollapseEvent) => void;
}

export interface TreeViewField extends BaseField {
    dataSourceUrl?: string;
    schema?: kendo.data.HierarchicalDataSourceSchema;
    template?: string;
    dataTextField?: any;
    imageUrlField?: string;
    cssClassField?: string;
    expand?: boolean;
    unselectableClass?: string;
}